<template>
  <b-modal
      id="1"
      :title="title"
      v-model="isOpenLocal"
      size="lg"
      scrollable
      :hide-footer="hideFooter"
      :ok-title="capitalize($t('validate'))"
      :cancel-title="capitalize($t('cancel'))"
      @hide="tryCloseSocialSecurityContributionsModal"
      @hidden="handleCancel"
      @ok="handleOk"
  >
    <validation-observer
        ref="observerRef"
        #default="{handleSubmit}">
      <b-form @submit.prevent="handleSubmit(submitValidatedSocialSecurityContributionsLocal)">

        <form-socialSecurityContributions
            :socialSecurityContributions="socialSecurityContributions"
            :allowEmpty="false"
            :isEdition="isEdition"
        />

        <button ref="submitSocialSecurityContributionsFormRef"
                class="d-none"></button>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { ValidationObserver } from 'vee-validate'
import { capitalize } from '../../utils/filter'

import useAPI from '../../utils/useAPI'
import i18n from '@/libs/i18n'
import FormSocialSecurityContributions from '@/components/form/socialSecurityContributions/SocialSecurityContributions'

export default {
  components: {
    ValidationObserver,
    FormSocialSecurityContributions
  },
  props: {
    socialSecurityContributions: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const isOpenLocal = ref(false)
    const socialSecurityContributionsLocal = ref(props.socialSecurityContributions)
    const submitSocialSecurityContributionsFormRef = ref(null)
    const observerRef = ref(null)

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const { currentBreakPoint } = useAPI()

    const hideFooter = computed(() => {
      return !['xs', 'sm'].includes(currentBreakPoint.value)
    })

    const isEdition = computed(() => {
      return props.title == i18n.t('EditSocialSecurityContribution')
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------
    watch(isOpenLocal, (val) => {
      emit('update:isOpen', val)
    })
    watch(socialSecurityContributionsLocal, (val) => {
      emit('update:socialSecurityContributions', val)
    })

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const tryCloseSocialSecurityContributionsModal = (modalEvent) => {
      if (modalEvent.trigger == 'backdrop') {
        // Click outside
        modalEvent.preventDefault()
        submitSocialSecurityContributionsFormRef.value.click()
      }
    }

    const submitValidatedSocialSecurityContributionsLocal = () => {
      emit('submitValidated')
    }

    const handleOk = async (bvModalEvent) => {
      bvModalEvent.preventDefault()

      const isValid = await observerRef.value.validate()
      if (isValid) {
        submitValidatedSocialSecurityContributionsLocal()
      }
    }

    const handleCancel = () => {}

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      capitalize,

      // Data
      isOpenLocal,
      socialSecurityContributionsLocal,
      submitSocialSecurityContributionsFormRef,
      observerRef,

      // Computed
      hideFooter,
      isEdition,

      // Methods
      tryCloseSocialSecurityContributionsModal,
      submitValidatedSocialSecurityContributionsLocal,
      handleOk,
      handleCancel,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {
    socialSecurityContributions: function (val) {
      this.socialSecurityContributionsLocal = val
    },
    isOpen: function (val) {
      this.isOpenLocal = val
    }
  },
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>